<template>
  <el-input
    v-model="formModel[field]"
    type="text"
    :maxlength="options['maxlength']"
    :minlength="options['minlength']"
    :show-word-limit="options['showWordLimit']"
    :placeholder="options['placeholder'] || `请输入${options['label']}`"
    :clearable="options['clearable'] !== false"
    :disabled="options['disabled']"
    :prefix-icon="options['prefixIcon']"
    :suffix-icon="options['suffixIcon']"
    :readonly="options['readonly']"
  />
</template>

<script>
export default {
  name: 'CustomFormText',
  props: {
    formModel: {
      type: Object,
      require: true,
      default: () => {
        return {}
      }
    },
    field: {
      type: String,
      require: true,
      default: ''
    },
    options: {
      type: Object,
      require: true,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
